/******************************************************************************\
 * File: Upload.jsx
 *
 * Author: Gigster
 *
 * Description:
 *
 * Notes:
 \******************************************************************************/

//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import * as style from '@/style/common/icons/Icon.scss';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class Upload extends React.Component {
    render() {
        const { className, onClick } = this.props;

        const cn = classNames(style.Icon, {
            [style['clickable']]: onClick,
            [style['no-fill']]: false,
            [className]: !!className
        });

        return (
            <svg width="14px" height="16px" viewBox="0 0 14 16">
                <g
                    id="GPX-Import"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                    opacity="1"
                >
                    <g
                        id="GPX-Import---disabled-hover-and-modal"
                        transform="translate(-838.000000, -931.000000)"
                        fill="#FFFFFF"
                    >
                        <g
                            id="footer"
                            transform="translate(0.000000, 908.000000)"
                        >
                            <g
                                id="import-gpx"
                                transform="translate(837.000000, 22.000000)"
                            >
                                <g
                                    id="Icon/Upload"
                                    transform="translate(0.000000, 1.000000)"
                                >
                                    <path
                                        d="M14,10 C14.5522847,10 15,10.4477153 15,11 L15,13 C15,14.2886644 13.9553311,15.3333333 12.6666667,15.3333333 L3.33333333,15.3333333 C2.04466892,15.3333333 1,14.2886644 1,13 L1,11 C1,10.4477153 1.44771525,10 2,10 C2.55228475,10 3,10.4477153 3,11 L3,13 C3,13.1840949 3.14923842,13.3333333 3.33333333,13.3333333 L12.6666667,13.3333333 C12.8507616,13.3333333 13,13.1840949 13,13 L13,11 C13,10.4477153 13.4477153,10 14,10 Z M8,-1.13686838e-13 L8.03302817,0.000542183715 C8.05037122,0.00111175045 8.06770228,0.00213006672 8.08508568,0.00356892193 C8.10633112,0.00535902069 8.12738748,0.00781332611 8.14771218,0.0109054105 C8.1674836,0.0138421398 8.18718391,0.0173719952 8.20750673,0.0215575567 C8.22270239,0.0247642698 8.23777082,0.0283160272 8.25200857,0.03210978 C8.27356531,0.0377008046 8.29497185,0.0440219704 8.31666861,0.0511777005 C8.33596336,0.0576143317 8.35499644,0.0646230445 8.37332302,0.072021301 C8.38976529,0.0786271328 8.40606756,0.0856873825 8.42228533,0.0932736716 L8.42228533,0.0932736716 L8.47815341,0.121426076 C8.49354877,0.129813374 8.5087703,0.138635175 8.52441383,0.148372374 C8.54569831,0.161506813 8.56645332,0.175416865 8.58642573,0.189814698 L8.58642573,0.189814698 L8.624,0.219 L8.70710678,0.292893219 L11.3737734,2.95955989 C11.7642977,3.35008418 11.7642977,3.98324916 11.3737734,4.37377345 C10.9832492,4.76429774 10.3500842,4.76429774 9.95955989,4.37377345 L9.95955989,4.37377345 L8.99933333,3.41433333 L9,10.3333333 C9,10.8856181 8.55228475,11.3333333 8,11.3333333 C7.44771525,11.3333333 7,10.8856181 7,10.3333333 L7,10.3333333 L6.99933333,3.41533333 L6.04044011,4.37377345 C5.64991582,4.76429774 5.01675084,4.76429774 4.62622655,4.37377345 C4.23570226,3.98324916 4.23570226,3.35008418 4.62622655,2.95955989 L4.62622655,2.95955989 L7.29289322,0.292893219 C7.31990717,0.265879271 7.34845949,0.2404037 7.37878047,0.216244716 C7.39173555,0.20595004 7.40488686,0.196022936 7.41781334,0.186850899 C7.43814667,0.172267065 7.45904955,0.158426988 7.48040379,0.145316865 L7.49625168,0.135876634 L7.49625168,0.135876634 L7.51225033,0.126810667 L7.51225033,0.126810667 L7.57864012,0.0928065398 L7.57864012,0.0928065398 L7.62625228,0.0721837115 C7.64500356,0.0646230445 7.66403664,0.0576143317 7.68381105,0.0510732771 C7.70426419,0.0442758658 7.72489337,0.0381569619 7.74527098,0.0327339553 C7.76144792,0.0284852806 7.77778494,0.0246316746 7.79447731,0.0212304256 C7.81341199,0.0172729429 7.83243923,0.0138687347 7.85103878,0.0110193427 L7.85103878,0.0110193427 L7.917,0.003 L7.919,0.003 L7.92476146,0.00278786299 L7.929,0.002 L7.92,0.003 L8,-1.13686838e-13 Z"
                                        id="upload"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        );
    }
}
export default Upload;
